import Mock from "../mock";

const firstName = "Tomer";
const lastName = "Ovadia";
const email = "o.tomerr@gmail.com";

const startYear = 2010;
const currentYear = new Date().getFullYear();
const yearsOfExperience = currentYear - startYear;

const database = {
  information: {
    name: `${firstName} ${lastName}`,
    aboutContent:
      `With ~${yearsOfExperience} years of experience, I architect scalable, highly observable AI/ML platforms specializing in Generative AI and conversational systems, building resilient solutions optimized for speed and reliability that tackle complex unstructured problems and deliver meaningful value at scale.`,
    // age: 24,
    phone: "",
    nationality: "Israeli",
    language: "English",
    email: email,
    title: "Senior Software Engineer",
    address: "Israel",
    // freelanceStatus: "Available",
    socialLinks: {
      facebook: "",
      twitter: "",
      pinterest: "",
      behance: "",
      email: `mailto:${email}`,
      linkedin: "https://www.linkedin.com/in/tomerovadia",
      dribbble: "",
      github: "https://github.com/otomer",
      medium: "https://medium.com/@tomero",
    },
    brief: "Determined, Driven, Dedicated </>",
    brandImage: "/me.png",
    aboutImage: "/craft.png",
    aboutImageLg: "/craft.png",
    cvfile: "/files/empty.pdf",
    aboutContactCta: "Contact Me",
  },
  services: [
    {
      title: "Experience-Driven Engineering",
      icon: "user",
      details:
        "Design systems with the user at the center, transforming technical capabilities into intuitive and enjoyable experiences that drive engagement, conversion and business impact while preserving performance and reliability.",
    },
    {
      title: "System Architecture",
      icon: "vector",
      details:
        "Architect feasible, durable and flexible distributed systems with strong modularity, traceability and observability, creating resilient foundations that support rapid iteration, long term evolution and cross organizational scalability.",
    },
    {
      title: "Distributed Intelligence at Scale",
      icon: "bulb",
      details:
        "Architect intelligent platforms that manage business logic through orchestration of machine learning models, agentic systems and deterministic pipelines, enabling adaptive and deeply personalized behavior across production environments.",
    },
  ],
  reviews: [
    {
      id: 1,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam, aliquid maxime tempora.",
      author: {
        name: "Burdette Turner",
        designation: "Web Developer, Abc Company",
      },
    },
    {
      id: 2,
      content:
        "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
      author: {
        name: "Susan Yost",
        designation: "Client",
      },
    },
    {
      id: 3,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
      author: {
        name: "Irving Feeney",
        designation: "Fiverr Client",
      },
    },
  ],
  skills: [
    {
      title: "Platform Architecture",
      value: 95,
    },
    {
      title: "Distributed Systems",
      value: 95,
    },
    {
      title: "Machine Learning",
      value: 90,
    },
    {
      title: "Multi-Agent Systems",
      value: 90,
    },
    {
      title: "Personalization Systems",
      value: 90,
    },
    {
      title: "Workflow Orchestration",
      value: 85,
    },
    {
      title: "End-to-End Ownership",
      value: 95,
    },
    {
      title: "System Design",
      value: 95,
    },
    {
      title: "Technical Leadership",
      value: 90,
    },
    {
      title: "Operational Excellence",
      value: 90,
    },
  ],
  portfolios: [
    {
      id: 1,
      title: "BrowserBuddy Chrome Extension",
      subtitle: "View all the data available about you when browse a page.",
      imageUrl: "/images/browserbuddy-440x280.png",
      largeImageUrl: ["/images/browserbuddy-920x680.png"],
      url: "https://browserbuddy.me/",
    },
    {
      id: 2,
      title: "Coronavirus Pandemic Live Statistics",
      subtitle:
        "Coronavirus (COVID-19) pandemic live statistics and news tracking historical data, daily charts, graphs, a per country view and more!",
      imageUrl: "/images/portfolio-image-4.jpg",
      largeImageUrl: [
        "/images/portfolio-image-4-lg.jpg",
        "/images/portfolio-image-4-lg2.jpg",
      ],
      url: "https://coronavirus-epidemic.com",
    },
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "01/2020 - Now",
        position: "Senior Software Engineer II",
        company: "Booking.com (AI and Machine Learning Centre)",
        details: "",
      },
      {
        id: 2,
        year: "12/2018 - 01/2020",
        position: "Software Engineer",
        company: "WeWork",
        details: "",
      },
      {
        id: 3,
        year: "09/2014 - 10/2018",
        position: "Senior Software Engineer",
        company: "LivePerson",
        details: "",
      },
      {
        id: 4,
        year: "05/2013 - 08/2014",
        position: "Web Developer",
        company: "Elipaz Software",
        details: "",
      },
      {
        id: 5,
        year: "10/2013 - 07/2014",
        position: "Mobile Web Developer",
        company: "miLAB Media Innovation Lab, IDC",
        details: "",
      },
      {
        id: 6,
        year: "05/2010 - 09/2012",
        position: "Web Developer",
        company: "Walla! and Yad 2",
        details: "",
      },
    ],
    educationExperience: [
      {
        id: 1,
        year: "2011 - 2014",
        graduation: "Bachelor, Computer Science",
        university: "IDC Herzliya, Efi Arazi School",
        details: "Taking part in miLAB (Media Innovation Lab) Program",
      },
      {
        id: 2,
        year: "2009 - 2010",
        graduation: "Microsoft .NET Developer",
        university: "John Bryce",
        details: "448 hours course",
      },
      {
        id: 3,
        year: "2002 - 2005",
        graduation: "High School Full Matriculation",
        university: "Tel Aviv, Irony Yud Dalet High School",
        details: "",
      },
    ],
  },
  blogs: [
    {
      id: 1,
      title: "Markdown & Html supported blog.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/markdown-html-supported-blog.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 2,
      title: "Installing NodeJS on your device.",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/installing-nodejs-on-your-device.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 3,
      title: "UI/UX design starter with Adobe XD.",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/uiux-design-starter-with-adobe-xd.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 4,
      title: "Boost your post for increasing sales.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/boost-your-post-for-increasing-sales.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 5,
      title: "Difference between GatsbyJS & NextJS.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/difference-between-gatsbyjs-and-nextjs.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 6,
      title: "How to choose javascript framework for project.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource:
        "../../blog/how-to-choose-javascript-framework-for-project.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 7,
      title: "Web automation with python language.",
      featuredImage: "/images/blog-image-7.jpg",
      filesource: "../../blog/web-automation-with-python-language.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 8,
      title: "Time to use latest technology for creating a website.",
      featuredImage: "/images/blog-image-8.jpg",
      filesource:
        "../../blog/time-to-use-latest-technology-for-creating-a-website.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 9,
      title: "Think out of the box.",
      featuredImage: "/images/blog-image-9.jpg",
      filesource: "../../blog/think-out-of-the-box.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 10,
      title: "Trending designs in 2020.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/trending-designs-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 11,
      title: "How to get 10k instagram followers?",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/how-to-get-10k-instagram-followers.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 12,
      title: "What NodeJS can do?",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/what-nodejs-can-do.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 13,
      title: "Futures of javascript.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/future-of-javascript.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 14,
      title: "Popular javascript library in 2020.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/popular-javascript-library-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 15,
      title: "Promrammers must read books.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/programmers-must-read-books.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
  ],
  contactInfo: {
    phoneNumbers: [],
    emailAddress: ["o.tomerr@gmail.com"],
    address: "Israel",
  },
};

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});
